// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "core.ruffle." + {"482":"eb2706134efd5e95832a","655":"b6ac34b06df17b9eedda"}[chunkId] + ".js";
};